import { vuexEventPathGenerator } from '@/utils';
import { mutationType } from './mutations';
export const actionType = {
    print: 'print',
};
export const allocationAlertActionType = vuexEventPathGenerator(actionType, 'allocationAlert');
const action = {
    /**
     * 우상단 배차 결과 팝업 출력
     */
    [actionType.print]({ commit }, payload = []) {
        payload.forEach((data) => {
            commit(mutationType.PRINT, data);
        });
    },
};
export default action;
